'use client'
import { useQueryClient } from '@tanstack/react-query'
import { TipButton } from '@web/app/[locale]/clubhouse/[slug]/_components/action-buttons/tip-button'
import { useSocialGiveTipToAnswerMutation } from '@web/gen/feed'
import { useUserCoinBalanceQuery } from 'codegen/generated/coins'
import * as React from 'react'
import type { Project } from '../../page-client'

interface Props {
  size?: 'small' | 'regular'
  project: Project
}

export const ProjectTipButton = ({ size, project }: Props) => {
  // eslint-disable-next-line cf-web/codegen-query-patterns
  const giveTipMutation = useSocialGiveTipToAnswerMutation()
  const queryClient = useQueryClient()

  function handleClickTip() {
    giveTipMutation.mutate(
      { input: { postId: +project.id } },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: useUserCoinBalanceQuery.getKey() })
        },
      },
    )
  }

  return <TipButton size={size} onTip={handleClickTip} />
}
